// https://github.com/daliborgogic/interpolation

export default defineNuxtPlugin((nuxtApp) => {
  const { public: config } = useRuntimeConfig()
  const { sanitizeUrl } = useSanitizeUrl()

  let links: any[] = []

  const navigate = (event: any) => {
    let href = event?.currentTarget?.getAttribute('href')
    let target = event?.currentTarget?.getAttribute('target') ?? '_self'

    // XSARUS CUSTOM START
    if (href.startsWith(config.productionDomain)) {
      href = href.replace(config.productionDomain, '/')
      target = '__blank'
    }

    // XSARUS CUSTOM END
    if (href?.startsWith('/')) {
      event.preventDefault()

      if (event.metaKey || target === '_blank') {
        window.open(href, '_blank', 'noopener')
      }
      else {
        navigateTo(href)
      }
    }
  }

  const removeListeners = (links: HTMLCollection) => {
    for (let i = 0; i < links.length; i++) {
      links[i]?.removeEventListener('click', navigate, false)
    }
    links = []
  }

  const addListeners = (links: HTMLCollection) => {
    for (let i = 0; i < links.length; i++) {
      // XSARUS CUSTOM START
      const link = links[i]

      if (!link) {
        continue
      }

      // XSARUS CUSTOM START
      const href = link.getAttribute('href') || ''
      const protocol = href.split(':')?.[0] || ''

      let rel = link.getAttribute('rel') || ''
      let target = link.getAttribute('target') || ''

      link.removeAttribute('rel')
      link.removeAttribute('target')

      if (target === 'undefined') {
        target = ''
      }

      // Convert internal links to relative links
      if (!['mailto', 'tel'].includes(protocol)) {
        let newHref = sanitizeUrl(href)

        if (newHref.startsWith('http')) {
          target = target || '_blank'
        }
        else if (!newHref.startsWith(config.productionDomain)) {
          newHref = sanitizeUrl(config.productionDomain + newHref)
        }

        link.setAttribute('href', newHref)
      }

      if (target) {
        link.setAttribute('target', target)
      }
      // XSARUS CUSTOM END

      if (target === '_blank') {
        rel = rel.replace('noopener', '').replace('noreferrer', '') + ' noopener noreferrer'
        link.setAttribute('rel', rel.trim())
      }

      link.addEventListener('click', navigate, false)
    }
  }

  nuxtApp.vueApp.directive('interpolation', {
    updated() {
      removeListeners(links)
      addListeners(links)
    },
    mounted(el) {
      console.warn('! Deprecated: use <UiRichtext :html="" /> instead !')
      links = el.getElementsByTagName('a')
      addListeners(links)
    },
    beforeUnmount(el) {
      el.removeEventListener('click', removeListeners(links))
    },
    // beforeMount(element: HTMLElement) {
    //   const links = Array.from(element.getElementsByTagName('a'))
    //   addListeners(links)
    // },

    // beforeUpdate: (element: HTMLElement) => {
    //   const links = Array.from(element.getElementsByTagName('a'))
    //   removeListeners(links)
    // },

    // updated: (element: HTMLElement) => {
    //   const links = Array.from(element.getElementsByTagName('a'))
    //   addListeners(links)
    // },

    // unmounted: (element: HTMLElement) => {
    //   const links = Array.from(element.getElementsByTagName('a'))
    //   removeListeners(links)
    // },
  })
})
